/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_1Inputs */



/**
* | output |
* | --- |
* | "Configuration and regular review of regex templates" |
*
* @param {Guardrails_Section_3_Your_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_1 = /** @type {((inputs?: Guardrails_Section_3_Your_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfiguration und regelmäßige Überprüfung der Regex-Templates")
	return /** @type {LocalizedString} */ ("Configuration and regular review of regex templates")
});